<template>
  <div>
    <div v-if='data.multiline'>
      <ejs-textbox
        :placeholder='data.placeholder'
        :enabled='data.enabled'
        :name='data.name'
        v-model='data.value'
        multiline="true">
      </ejs-textbox>
    </div>
    <div v-else>
      <ejs-textbox
        :placeholder='data.placeholder'
        :enabled='data.enabled'
        :name='data.name'
        v-model='data.value'>
      </ejs-textbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormText',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    opCode: {
      type: String,
      default: ''
    },
    formParam: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    },
    defaultData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      cellMap: {}
    };
  },
  beforeMount() {
    const $this = this;
    const datailData = JSON.stringify($this.defaultData) !== '{}' ? JSON.parse($this.defaultData.paramsJson) : '';
    $this.data.enabled = this.opCode === 'detail' ? false : this.data.enabled;
    $this.data.placeholder = this.opCode === 'detail' ? '' : this.data.placeholder;
    // $this.data.enabled = datailData !== '' ? false : $this.data.enabled;
    if (this.opCode === 'detail' && $this.data.name === 'cellsId') {
      // this.data.value = (data && data[this.data.name]) ? data[this.data.name] : this.data.value;
      // this.data.value = this.data.value.replace(/\[|\]/g, '');
      const idArr = JSON.parse(datailData[$this.data.name]);
      this.$axios.get(`/lte/ems/track/queryCellTree/${datailData.neId}`).then(response => {
        if (response && response.status === 200) {
          const responseData = response.data.resultVal ? response.data.resultVal : [];
          $this.cellMap = new Map();
          $this.getCellName(responseData);
          const nameArr = idArr.map((id) => {
            return $this.cellMap.get(id.toString());
          })
          $this.data.value = nameArr.toString();
        } else {
          EventBus.$emit('toast', {type: 'error', content: $this.$t('Track.error')});
        }
      });
    } else {
      this.data.value = (datailData && datailData[$this.data.name]) ? datailData[$this.data.name] : $this.data.value;
    };
  },
  methods: {
    getCellName(result) {
      result.forEach((data) => {
        this.cellMap.set(data.id, data.text);
        if (data.children !== null) {
          this.getCellName(data.children);
        }
      })
    }
  }
};
</script>

<style>

</style>
